class WishWeek{

    constructor(numberOfIntervals, weekNumber, ignoreAOnPublicHoliday){
        this.wishDays = new Array(6);
        this.numberOfIntervals = numberOfIntervals;
        this.weekNumber = weekNumber;
        this.ignoreAOnPublicHoliday = ignoreAOnPublicHoliday;
        this.NUMBER_OF_NEW_INTERVALS = 96;
    }
    setDays(){ //Achtung, sind im MAT die Uhrzeiten von 6-24 Uhr, so muss die Klasse WishWeekFromSixToTwelve genutzt werden.
        let weekdays = ["mo", "di", "mi", "do", "fr", "sa", "so"];
        for(let i = 0; i < weekdays.length; i++) {
            let feiertag = !isACountedOnDay(document.getElementById("w" + this.weekNumber + "_tagname" + (i+1)).innerHTML, this.ignoreAOnPublicHoliday); //boolean will be toggled
            this.wishDays[i]= new WishDay(feiertag, weekdays[i]);
            for (let j = 0; j < this.numberOfIntervals; j++) {
                this.wishDays[i].setInterval(j, document.getElementById("w" + this.weekNumber + "_" + weekdays[i] + (j)).value);
            }
        }
    }

    isAOnDaysBetweenTimeIntervals(day, timeIntervalFrom, timeIntervalUntil){
        for (let i = timeIntervalFrom; i < timeIntervalUntil; i++){
            let wertIntervall = this.wishDays[day].getInterval(i);
            if(wertIntervall != 'A' && wertIntervall != 'P' ){
                return false;
            }
        }
        return true;
    }

    isAOnDaysBeforeTime(day, timeIntervall){
        for(let i = timeIntervall; i >= 0; i --){
            let wertIntervall = this.wishDays[day].getInterval(i);
            if(wertIntervall == 'A' || wertIntervall == 'P' ){
                return true;
            }
        }
        return false;
    }
    isAOnDaysAfterTime(day, timeIntervall){
        for(let i = timeIntervall; i < 96; i ++){
            let wertIntervall = this.wishDays[day].getInterval(i);
            if(wertIntervall == 'A' || wertIntervall == 'P' ){
                return true;
            }
        }
        return false;
    }
    getNumberOfAIntervalls(day){
        let numberOfAIntervallsOnDay = 0;
        for(let i = 0; i < 96; i ++){
            let valueInterval = this.wishDays[day].getInterval(i);
            if(valueInterval == 'A'){
                numberOfAIntervallsOnDay ++;
            }
        }
        return numberOfAIntervallsOnDay;
    }
    getNumberOfASegments(day){
        let numberOfSegmentsOnDay = 0;
        let lastIntervalNotA = true;
        for(let i = 0; i < 96; i ++){
            let valueInterval = this.wishDays[day].getInterval(i);
            if(valueInterval == 'A' && lastIntervalNotA){
                lastIntervalNotA = false;
                numberOfSegmentsOnDay ++;
            }else if(valueInterval != 'A' && valueInterval != 'P'){
                lastIntervalNotA = true;
            }
        }
        return numberOfSegmentsOnDay;
    }
    getNumberOfIntervalsBetweenTwoASegments(day){
        let numberOfIntervalsBetweenSegments = 0;
        let aSegmentBegun = false;
        let aSegmentEnd = false;
        for(let i = 0; i < 96; i ++){
            let valueInterval = this.wishDays[day].getInterval(i);
            if(valueInterval == 'A' && aSegmentBegun == true && aSegmentEnd == true){
                return numberOfIntervalsBetweenSegments;
            }
            if(valueInterval != 'A' && aSegmentBegun == true){
                aSegmentEnd = true;
                numberOfIntervalsBetweenSegments ++;
            }
            if(valueInterval == 'A' && aSegmentBegun == false){
                aSegmentBegun = true;
            }
        }
        return numberOfIntervalsBetweenSegments;
    }
    getNumberOfIntervalsFirstSegment(day, wishBreak){
        let numberOfSegmentsOnDay = 0;
        let aSegmentBegun = false;
        for(let i = 0; i < 96; i ++){
            let valueInterval = this.wishDays[day].getInterval(i);
            if(valueInterval != 'A' && valueInterval != 'P' && aSegmentBegun && wishBreak == 0){
                return numberOfSegmentsOnDay;
            }else if(valueInterval != 'A' && aSegmentBegun && wishBreak == 1){
                return numberOfSegmentsOnDay;
            }else if(valueInterval == 'A'){
                if(!aSegmentBegun){
                    aSegmentBegun = true;
                }
                numberOfSegmentsOnDay ++;
            }
        }
        return numberOfSegmentsOnDay;
    }
    getNumberOfIntervalsLastSegment(day, wishBreak){
        let numberOfSegmentsOnDay = 0;
        let aSegmentBegun = false;
        for(let i = 96; i > 0; i --){
            let valueInterval = this.wishDays[day].getInterval(i);
            if(valueInterval != 'A' && valueInterval != 'P' && aSegmentBegun && wishBreak == 0){
                return numberOfSegmentsOnDay;
            } else if(valueInterval != 'A' && aSegmentBegun && wishBreak == 1){
                return numberOfSegmentsOnDay;
            }else if(valueInterval == 'A'){
                if(!aSegmentBegun){
                    aSegmentBegun = true;
                }
                numberOfSegmentsOnDay ++;
            }
        }
        return numberOfSegmentsOnDay;
    }
    isPublicHoliday(dayOfWeek){
        if(this.wishDays[dayOfWeek].getPublicHoliday() == true) {
            return 1;
        }else{
            return 0;
        }
    }
}